import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getGenerations,
  getGenerationsByModel,
  createGeneration,
  updateGeneration,
  deleteGeneration,
} from '../../lib/vehicleGenerations';

export const fetchGenerations = createAsyncThunk(
  'generations/getGenerations',
  async () => {
    const data = await getGenerations();
    return data;
  }
);

export const fetchGenerationsByModel = createAsyncThunk(
  'models/fetchGenerationsByModel',
  async ({ vehicleModelId }) => {
    const data = await getGenerationsByModel(vehicleModelId);

    return data;
  }
);

export const addGeneration = createAsyncThunk(
  'generations/addGeneration',
  async (body, { rejectWithValue }) => {
    try {
      const data = await createGeneration(body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editGeneration = createAsyncThunk(
  'generations/editGeneration',
  async ({ generationId, body }) => {
    const data = await updateGeneration(generationId, body);
    return data;
  }
);

export const removeGeneration = createAsyncThunk(
  'generation/removeGeneration',
  async (generationId) => {
    await deleteGeneration(generationId);
    return generationId;
  }
);
